<template>
  <v-chip :color="statusObject.color"
          label
          small
          :dark="statusObject.darkMode"
          class="text-center font-weight-bold"
          :class="{'d-block': block}"
          v-bind="$attrs"
          v-on="$listeners">
    {{ statusObject.text }}
  </v-chip>
</template>
<script>
import neverbounceService from '../../../services/neverbounceService';

export default {
  props: {
    status: {
      type: String,
      required: true,
    },
    block: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      statusCodes: neverbounceService.getStatusCodes(),
    }
  },
  computed: {
    statusObject() {
      return neverbounceService.getStatusCode(this.status);
    },
  }
}
</script>
